export default "__VITE_ASSET__3Edj4bn0__"